import { isKeyHotkey } from 'is-hotkey';

import { shortcuts } from '../../../Keyboard';

export const isEnter = isKeyHotkey('enter');
export const isSpace = isKeyHotkey('space');
export const isShiftEnter = isKeyHotkey('shift+enter');
export const isModEnter = isKeyHotkey('mod+enter');
export const isOptionEnter = isKeyHotkey('alt+enter');
export const isOptionShiftEnter = isKeyHotkey('alt+shift+enter');
export const isModMinus = isKeyHotkey('mod+-');
export const isModShiftSlash = isKeyHotkey('mod+shift+/');
export const isBackspace = isKeyHotkey('backspace');
export const isDelete = isKeyHotkey('delete');
export const isTab = isKeyHotkey('tab');
export const isShiftTab = isKeyHotkey('shift+tab');
export const isModA = isKeyHotkey('mod+a');
export const isEscape = isKeyHotkey('esc');

export const isEditorBold = isKeyHotkey(shortcuts.EDITOR_BOLD);
export const isEditorItalic = isKeyHotkey(shortcuts.EDITOR_ITALIC);
export const isEditorCode = isKeyHotkey(shortcuts.EDITOR_CODE);
export const isEditorStrikethrough = isKeyHotkey(shortcuts.EDITOR_STRIKETHROUGH);
export const isEditorSuperscript = isKeyHotkey(shortcuts.EDITOR_SUPERSCRIPT);
export const isEditorSubscript = isKeyHotkey(shortcuts.EDITOR_SUBSCRIPT);
export const isEditorAnnotation = isKeyHotkey(shortcuts.EDITOR_ANNOTATION);
export const isEditorLink = isKeyHotkey(shortcuts.EDITOR_LINK);
